import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import OpenerImage from '../common/opener_image';
import { sendAnalyticsEvent } from '../../utils/analytics';

export default class PremiumCard extends Component {
  handleClick = () =>
    this.props.moduleType === 'all-shows' &&
    sendAnalyticsEvent(
      'All Shows',
      'Click',
      `${this.props.display_name} ${this.props.indexWithinModule}`
    );

  render = () => (
    <div className="card premium" onClick={this.handleClick}>
      <Link to={this.props.path}>
        <OpenerImage rowType={this.props.rowType}
          opener_images={this.props.opener_images}
        />
        <div className="premium-card-content">
          <div className="title"
            dangerouslySetInnerHTML={{ __html: this.props.display_name }}
          />
          <div className="cta">
            <RosettaFormattedMessage parentFilename={__filename}
              id="series_cta"
              description={
                'Call to action for Premium Title Cards linking to a series'
              }
              defaultMessage="Watch Now"
            />
          </div>
        </div>
      </Link>
    </div>
  );
}

PremiumCard.propTypes = {
  name: PropTypes.string.isRequired,
  display_name: PropTypes.string.isRequired,
  opener_images: PropTypes.arrayOf(PropTypes.object).isRequired,
  path: PropTypes.string.isRequired,
  rowType: PropTypes.string.isRequired,
  moduleType: PropTypes.string.isRequired,
  indexWithinModule: PropTypes.number.isRequired
};
